import { jsonSchema } from "@redotech/redo-automations-model/graph/automation";
import * as z from "zod";

const effectClass = z.enum(["pure", "read", "write", "external", "wait"]);

export const catalogTriggerSchema = z.object({
  id: z.string(),
  version: z.number().int(),
  domain: z.string().nullable(),
  domainTitle: z.string(),
  group: z.string(),
  title: z.string(),
  description: z.string(),
  icon: z.string(),
  /** Domain event the trigger listens for. */
  event: z.string(),
  effects: z.array(effectClass),
  /** Shown but not selectable, with the reason. */
  unavailableReason: z.string().nullable(),
  defaultConfig: jsonSchema,
  configJsonSchema: jsonSchema,
  exampleEvent: jsonSchema,
});
export type CatalogTrigger = z.infer<typeof catalogTriggerSchema>;

export const catalogStepSchema = z.object({
  id: z.string(),
  version: z.number().int(),
  domain: z.string().nullable(),
  domainTitle: z.string(),
  category: z.enum(["action", "condition"]),
  group: z.string(),
  title: z.string(),
  description: z.string(),
  icon: z.string(),
  effects: z.array(effectClass),
  skippable: z.boolean(),
  /** Escape hatches (code, raw HTTP): why the step can't be checked. */
  unsafe: z.string().nullable(),
  /** Not offered in the palette, with the reason; still valid in automations. */
  hidden: z.string().nullable(),
  /** Ports of the default config; ports can depend on settings. */
  ports: z.array(z.object({ id: z.string(), label: z.string() })),
  defaultConfig: jsonSchema,
  configJsonSchema: jsonSchema,
  /** With `triggerKind`: whether an automation on that trigger can use the step, and why not. */
  availability: z
    .object({ ok: z.boolean(), reason: z.string().nullable() })
    .nullable(),
});
export type CatalogStep = z.infer<typeof catalogStepSchema>;

/** Trigger and step kinds for the editor palette and inspector forms. */
export const getCatalog = {
  name: "getCatalog" as const,
  input: z.object({ triggerKind: z.string().optional() }),
  output: z.object({
    triggers: z.array(catalogTriggerSchema),
    steps: z.array(catalogStepSchema),
  }),
};
